const window = require('window');
const Backbone = require('backbone');
const ProductHelper = Backbone.View.extend({
	/**
	 * @private
	 * @param {*} productModel
	 * @returns {boolean}
	 */
	_isNoModel: function(productModel) {
		return !productModel || !Object.keys(productModel).length;
	},
	/**
	 * @private
	 * @param {*[]} finishes
	 * @param {string | number} uniqueId
	 * @returns {*}
	 */
	_getSelectedFinishFromArray(finishes, uniqueId) {
		if (Array.isArray(finishes) && finishes.length) {
			if (uniqueId) {
				return (
					finishes.find((finish) => {
						return finish.uniqueId === uniqueId || (finish.get && finish.get('uniqueId') === uniqueId);
					}) || finishes[0]
				);
			} else {
				return finishes[0];
			}
		}
		return null;
	},

	/**
	 * @param {*} productModel
	 * @param {*} saveSubItems
	 * @param {boolean} saveAll
	 * @param {*} quantityOverride
	 * @param {*} sessionCartId
	 * @returns {*}
	 */
	getDefaultCartItemModelConfig: function(
		productModel,
		saveSubItems,
		saveAll = false,
		quantityOverride = null,
		sessionCartId = null,
		searchId = null
	) {
		if (this._isNoModel(productModel)) {
			return {};
		}
		const cartItemModelConfig = {
			quantity: quantityOverride || productModel.getQuantity(),
			uniqueId: this.getUniqueId(productModel),
			searchId,
			subItems: productModel.recommendedOptions.getDecoratedSelectedOptions(),
			hasPricedOptions: productModel.hasPricedOptions(),
			pricedOptions: productModel.optionGroups.getDecoratedSelectedOptions(),
			saveSubItems: saveSubItems,
			saveAll: window.BCOM.data.saveAll || saveAll,
			parentItemKey: productModel.get('parentItemKey'),
			cartItemId: productModel.get('cartItemId')
		};

		if (sessionCartId) {
			cartItemModelConfig.sessionCartId = sessionCartId;
		}

		return cartItemModelConfig;
	},

	/**
	 * @param {*} productModel
	 * @returns {*}
	 */
	getSelectedFinish(productModel) {
		if (this._isNoModel(productModel)) {
			return null;
		}
		const finishes = productModel.finishes || (productModel.get && productModel.get('finishes')) || null,
			uniqueId = (productModel.get && productModel.get('uniqueId')) || productModel.uniqueId;

		if (finishes) {
			if (finishes.getSelectedFinish) {
				const selectedFinish = finishes.getSelectedFinish();
				if (selectedFinish) {
					return selectedFinish;
				}
			}
			return this._getSelectedFinishFromArray(finishes, uniqueId);
		}

		return null;
	},

	/**
	 * @param {*} productModel
	 * @returns {*}
	 */
	getUniqueId(productModel) {
		if (this._isNoModel(productModel)) {
			return null;
		}
		const uniqueId = (productModel.get && productModel.get('uniqueId')) || productModel.uniqueId,
			selectedFinish = this.getSelectedFinish(productModel);
		if (selectedFinish) {
			if (selectedFinish.uniqueId) {
				return selectedFinish.uniqueId;
			}
			if (selectedFinish.get) {
				return selectedFinish.get('uniqueId') || uniqueId || null;
			}
		}
		return uniqueId;
	},

	/**
	 * @param {*} productModel
	 * @param {number} size
	 * @returns {*}
	 */
	getSelectedFinishImage(productModel, size = 100) {
		const noImageURL = '/imagebase/resized/140x140/404images/noimage.gif';
		if (this._isNoModel(productModel)) {
			return null;
		}
		const selectedFinish = this.getSelectedFinish(productModel),
			image = productModel.image || (productModel.get && productModel.get('image')) || noImageURL,
			images = productModel.images || (productModel.get && productModel.get('images')) || null;
		if (selectedFinish) {
			const selectedFinishImages = selectedFinish.images || (selectedFinish.get && selectedFinish.get('images')) || null,
				selectedFinishImage = selectedFinish.image || (selectedFinish.get && selectedFinish.get('image'));

			if (selectedFinishImages) {
				const selectedImage = selectedFinishImages[size] || selectedFinishImages[100] || selectedFinishImage;
				if (selectedImage) {
					return selectedImage;
				}
			}
		}
		if (images) {
			return images[size] || images[100] || image;
		}
		return image;
	}
});

module.exports = new ProductHelper();
